"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hex = exports.getRGB = exports.getR = exports.getG = exports.getB = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.parse-int.js");
require("core-js/modules/es.regexp.to-string.js");
function cov_tzjvel88() {
  var path = "/__w/code/code/js/packages/bricks/src/helpers/convertColor.ts";
  var hash = "3a79de90d6d5f9a9834e3ef4fe377a34586204bd";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/helpers/convertColor.ts",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 19
        },
        end: {
          line: 2,
          column: 69
        }
      },
      "1": {
        start: {
          line: 2,
          column: 2
        },
        end: {
          line: 2,
          column: 69
        }
      },
      "2": {
        start: {
          line: 4,
          column: 20
        },
        end: {
          line: 4,
          column: 66
        }
      },
      "3": {
        start: {
          line: 4,
          column: 35
        },
        end: {
          line: 4,
          column: 66
        }
      },
      "4": {
        start: {
          line: 5,
          column: 20
        },
        end: {
          line: 5,
          column: 66
        }
      },
      "5": {
        start: {
          line: 5,
          column: 35
        },
        end: {
          line: 5,
          column: 66
        }
      },
      "6": {
        start: {
          line: 6,
          column: 20
        },
        end: {
          line: 6,
          column: 63
        }
      },
      "7": {
        start: {
          line: 6,
          column: 35
        },
        end: {
          line: 6,
          column: 63
        }
      },
      "8": {
        start: {
          line: 8,
          column: 22
        },
        end: {
          line: 8,
          column: 86
        }
      },
      "9": {
        start: {
          line: 8,
          column: 39
        },
        end: {
          line: 8,
          column: 86
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 1,
            column: 19
          },
          end: {
            line: 1,
            column: 20
          }
        },
        loc: {
          start: {
            line: 2,
            column: 2
          },
          end: {
            line: 2,
            column: 69
          }
        },
        line: 2
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 4,
            column: 20
          },
          end: {
            line: 4,
            column: 21
          }
        },
        loc: {
          start: {
            line: 4,
            column: 35
          },
          end: {
            line: 4,
            column: 66
          }
        },
        line: 4
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 5,
            column: 20
          },
          end: {
            line: 5,
            column: 21
          }
        },
        loc: {
          start: {
            line: 5,
            column: 35
          },
          end: {
            line: 5,
            column: 66
          }
        },
        line: 5
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 6,
            column: 20
          },
          end: {
            line: 6,
            column: 21
          }
        },
        loc: {
          start: {
            line: 6,
            column: 35
          },
          end: {
            line: 6,
            column: 63
          }
        },
        line: 6
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 8,
            column: 22
          },
          end: {
            line: 8,
            column: 23
          }
        },
        loc: {
          start: {
            line: 8,
            column: 39
          },
          end: {
            line: 8,
            column: 86
          }
        },
        line: 8
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 2,
            column: 2
          },
          end: {
            line: 2,
            column: 69
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 2,
            column: 32
          },
          end: {
            line: 2,
            column: 52
          }
        }, {
          start: {
            line: 2,
            column: 55
          },
          end: {
            line: 2,
            column: 69
          }
        }],
        line: 2
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "3a79de90d6d5f9a9834e3ef4fe377a34586204bd"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_tzjvel88 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_tzjvel88();
cov_tzjvel88().s[0]++;
var hex = exports.hex = function hex(x) {
  cov_tzjvel88().f[0]++;
  cov_tzjvel88().s[1]++;
  return x.toString(16).length === 1 ? (cov_tzjvel88().b[0][0]++, '0' + x.toString(16)) : (cov_tzjvel88().b[0][1]++, x.toString(16));
};
cov_tzjvel88().s[2]++;
var getR = exports.getR = function getR(c) {
  cov_tzjvel88().f[1]++;
  cov_tzjvel88().s[3]++;
  return parseInt(c.substring(1, 3), 16);
};
cov_tzjvel88().s[4]++;
var getG = exports.getG = function getG(c) {
  cov_tzjvel88().f[2]++;
  cov_tzjvel88().s[5]++;
  return parseInt(c.substring(3, 5), 16);
};
cov_tzjvel88().s[6]++;
var getB = exports.getB = function getB(c) {
  cov_tzjvel88().f[3]++;
  cov_tzjvel88().s[7]++;
  return parseInt(c.substring(5), 16);
};
cov_tzjvel88().s[8]++;
var getRGB = exports.getRGB = function getRGB(hex) {
  cov_tzjvel88().f[4]++;
  cov_tzjvel88().s[9]++;
  return "rgb(".concat(getR(hex), ", ").concat(getG(hex), ", ").concat(getB(hex), ")");
};